import React from 'react';

import MuiChip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

import PropTypes from 'prop-types';

import ChipIcon from './components/chip-icon';
import styles from './styles';

export function Chip(props) {
  const {
    classes,
    label,
    onDelete,
    hasIcon,
    iconContent,
    iconColor,
    customIcon,
    ...other
  } = props;

  const StandardIcon = () =>
    hasIcon ? (
      <ChipIcon iconColor={iconColor} iconContent={iconContent} />
    ) : null;

  return (
    <MuiChip
      classes={classes}
      label={label}
      icon={customIcon ? customIcon : <StandardIcon />}
      deleteIcon={<CancelOutlinedIcon />}
      onDelete={onDelete}
      {...other}
    />
  );
}

Chip.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  /** Label for Chip */
  label: PropTypes.string,
  /** Function to fire when selecting delete icon.
   * Note: delete icon will only appear with this is present. */
  onDelete: PropTypes.func,
  /** Boolean to show the default icon */
  hasIcon: PropTypes.bool,
  /** Content to show with the default icon */
  iconContent: PropTypes.node,
  /** Background color of the default icon */
  iconColor: PropTypes.string,
  /** Custom Icon if default is not sufficient */
  customIcon: PropTypes.node
};

export default withStyles(styles)(Chip);
